// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3tByx","icon":"index_icon_3pa77"};